// // DisplayVehicles.js
// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { getFirestore, collection, getDocs } from 'firebase/firestore';
// import './displaypublicbus.css';
// import { getAuth } from 'firebase/auth';
// import { useNavigate } from 'react-router-dom';
// const DisplayVehicles = () => {
//   const [documentIds, setDocumentIds] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const firestore = getFirestore();
//   const navigate = useNavigate();
//   const auth = getAuth();
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       if (!user) {
//         // If the user is not authenticated, navigate to the login page
//         navigate("/login");
//       }
//     });
//     return () => unsubscribe();
//   }, [navigate]);
//   useEffect(() => {
//     const fetchDocumentIds = async () => {
//       try {
//         const querySnapshot = await getDocs(collection(firestore, 'publicbuses'));
//         const ids = querySnapshot.docs.map((doc) => doc.id);
//         setDocumentIds(ids);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching document IDs from Firestore:', error);
//         setLoading(false);
//       }
//     };

//     fetchDocumentIds();
//   }, [firestore]);

//   return (
//     <div className="display-vehicles-container">
//       <h2>Display Vehicles</h2>
//       {loading ? (
//         <p>Loading...</p>
//       ) : documentIds.length > 0 ? (
//         <ul>
//           {documentIds.map((documentId) => (
//             <li key={documentId}>
//               <Link to={`/VehicleDetails/${documentId}`}>{documentId}</Link>
//             </li>
//           ))}
//         </ul>
//       ) : (
//         <p>No vehicles found in the publicbuses collection.</p>
//       )}
//     </div>
//   );
// };

// export default DisplayVehicles;
// DisplayVehicles.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import './displaypublicbus.css';
import { getAuth } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const DisplayVehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const firestore = getFirestore();
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        // If the user is not authenticated, navigate to the login page
        navigate("/login");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const querySnapshot = await getDocs(collection(firestore, 'publicbuses'));
        const vehiclesData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setVehicles(vehiclesData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching vehicles from Firestore:', error);
        setLoading(false);
      }
    };

    fetchVehicles();
  }, [firestore]);

  return (
    <div >
      <h2>Display Vehicles</h2>
      {loading ? (
        <p>Loading...</p>
      ) : vehicles.length > 0 ? (
       
          <table className="vehicles-table">
          <thead>
            <tr>
              <th>ID</th>
             
             
            </tr>
          </thead>
          <tbody>
            {vehicles.map((vehicle) => (
              <tr key={vehicle.id}>
                <td><Link to={`/VehicleDetails/${vehicle.id}`}>{vehicle.id}</Link></td>
              
              </tr>
            ))}
          </tbody>
          </table>
        
      ) : (
        <p>No vehicles found in the publicbuses collection.</p>
      )}
    </div>
  );
};

export default DisplayVehicles;

